import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useVirtualizer } from "@tanstack/react-virtual";

const VirtualMenuList = ({ children }) => {
  const ref = useRef(null);

  const rowVirtualizer = useVirtualizer({
    count: React.Children.count(children),
    getScrollElement: () => ref.current,
    estimateSize: () => 32,
    overscan: 5,
  });

  if (!Array.isArray(children)) return children;

  const virtualItems = rowVirtualizer.getVirtualItems();

  return (
    <div ref={ref} className="tw-h-[320px] tw-overflow-y-auto tw-contain-strict">
      <div
        className="tw-w-full tw-relative"
        style={{
          height: rowVirtualizer.getTotalSize(),
        }}
      >
        <div
          className="tw-absolute tw-top-0 tw-left-0 tw-w-full"
          style={{
            transform: `translateY(${virtualItems[0]?.start ?? 0}px)`,
          }}
        >
          {virtualItems.map(({ key, index }) => (
            <div key={key} data-index={index} ref={rowVirtualizer.measureElement}>
              {children[index] || null}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

VirtualMenuList.propTypes = {
  children: PropTypes.node,
};

VirtualMenuList.defaultProps = {
  children: null,
};

export default VirtualMenuList;
